import { BlogsComponent } from './blogs/blogs.component';
import { Cerberus } from '../_helpers/Cerberus';
import { OhiUniversityComponent } from './ohi-university.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Page404homeComponent } from './page404home/page404home.component';
import { ResourcesComponent } from './resources/resources.component';
import { WebinarsComponent } from './webinars/webinars.component';


const homeRoutes: Routes = [
    {
        path: 'university', component: OhiUniversityComponent, canActivate:[Cerberus], children: [
            { path: 'webinars', component: WebinarsComponent, canActivate:[Cerberus] },
            { path: 'resources', component: ResourcesComponent, canActivate:[Cerberus] },
            { path: 'blogs', component: BlogsComponent, canActivate:[Cerberus] },            
            { path: '', redirectTo: 'webinars', pathMatch: 'full' },
            { path: '**', component: Page404homeComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(homeRoutes)],
    exports: [RouterModule]
})

export class OhiUniversityRoutingModule { }
